__webpack_require__.p = "http://drapieznik.loc:3505/themes/starter/assets/";